class RestaurantStorage {
  constructor() {
    this.LOCAL_STORAGE_RESTAURANT = "restaurant-info";
    this.LOCAL_STORAGE_RESTAURANT_UUID = "restaurant-uuid";
  }

  get restaurantUUID() {
    try {
      return localStorage.getItem(this.LOCAL_STORAGE_RESTAURANT_UUID);
    } catch (error) {
      return {};
    }
  }
  set restaurantUUID(data) {
    localStorage.setItem(this.LOCAL_STORAGE_RESTAURANT_UUID, data);
  }

  get restaurantInfo() {
    try {
      return JSON.parse(localStorage.getItem(this.LOCAL_STORAGE_RESTAURANT));
    } catch (error) {
      return {};
    }
  }
  set restaurantInfo(data) {
    localStorage.setItem(this.LOCAL_STORAGE_RESTAURANT, JSON.stringify(data));
  }
}

export default new RestaurantStorage();